import { RadioInputModule } from './../../libs/component-lib/components/forms/radio-input/radio-input.module';
import { TextInputModule } from './../../libs/component-lib/components/forms/text-input/text-input.module';
import { CheckboxBtnInputModule } from './../../libs/component-lib/components/forms/checkbox-btn-input/checkbox-btn-input.module';
import { CheckboxInputModule } from './../../libs/component-lib/components/forms/checkbox-input/checkbox-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EvsbVirtualCheckupMapper } from './evsb-virtual-checkup.mapper';
import { VirtualCheckupModalComponent } from './virtual-checkup-modal.component';
import { EvsbVirtualCheckupComponent } from './evsb-virtual-checkup.component';
import { NgModule } from '@angular/core';
import ButtonModule from '../../libs/component-lib/components/button/button-module';
import { DatepickerInputModule } from '../../libs/component-lib/components/forms/datepicker-input/datepicker-input.module';
import { EmailInputModule } from '../../libs/component-lib/components/forms/email-input/email-input.module';
import { PhoneInputModule } from '../../libs/component-lib/components/forms/phone-input/phone-input.module';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from '../../libs/component-lib/components/modal/modal.module';

@NgModule({
  declarations: [EvsbVirtualCheckupComponent, VirtualCheckupModalComponent],
  exports: [EvsbVirtualCheckupComponent, VirtualCheckupModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    DatepickerInputModule,
    CheckboxInputModule,
    CheckboxBtnInputModule,
    TextInputModule,
    EmailInputModule,
    PhoneInputModule,
    RadioInputModule,
    TranslateModule,
    ModalModule,
  ],
  providers: [EvsbVirtualCheckupMapper],
})
export class EvsbVirtualCheckupModule {}
